export class NotContainsSpecialCharacterError extends Error {
  constructor () {
    super('O campo deve ter ao menos um caractere especial')
    this.name = 'NotContainsSpecialCharacterError'
  }
}
